import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import {
  MatDatepicker,
  MatDatepickerModule,
  MatDatepickerToggle,
} from "@angular/material/datepicker";
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenu, MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { MatProgressBar } from "@angular/material/progress-bar";

import { MatSidenavContainer } from "@angular/material/sidenav";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";

import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { MatTab, MatTabGroup, MatTabsModule } from "@angular/material/tabs";

import { MatExpansionModule } from "@angular/material/expansion";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { CompanyService } from "../../configuration/company/company.service.service";
import {
  CompanyAttributes,
  DocumentClassAttributes,
  DocumentTypeAttributes,
  OrderAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { BehaviorSubject, Subscription, take } from "rxjs";
import { SalesDistributionService } from "./sales-distribution.service";
import {
  IMaterialListItem,
  IOrderMaterial,
  IUmOption,
  IUnitOfMeasure,
} from "./interfaces/order_material.interface";
import { IFilterMaterial } from "./interfaces/filter_material.interface";
import { RouteService } from "../../routing/route/route.service";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { RouteGroupService } from "../../routing/route-group/route-group.service";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { MaterialService } from "../../material/material/material.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { OfficeGroupService } from "../../configuration/office-group/office-group.service";
import OfficeGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity";
import { MaterialGroupService } from "../../material/material-group/material-group.service";
import MaterialGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity";
import { AuthService } from "app/core/auth/services/auth.service";
import { MatSelectModule } from "@angular/material/select";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { IOrderDetails } from "./interfaces/order_details.interface";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DateTime } from "luxon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IOptionFilterDistribution } from "./interfaces/option_filter.interface";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import { RouteAreaService } from "../../routing/route-area/route-area.service";
import { BusinessPartnerService } from "../../business-partners/business-partner/business-partner.service";
import {
  IPaginationResult,
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { LoadTableListComponent } from "../../monitor/table-load-list/table-load-list.component";
import { IumActive } from "./interfaces/umActive.interface";
import { TableListClientComponent } from "./table-list-client/table-list-client.component";
import { DistributionExport } from "./export/distribution.export";
import { SALE_DISTRIBUTION_EXPORT_TITLE } from "./export/distribution.constants";
import { TableNoSelectComponent } from "./table-no-select/table-no-select.component";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import {
  HasPermissionPipe,
  PermissionDirective,
  PermissionService,
} from "app/core/permission";
import { ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS } from "app/common/constants/permission";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";

import {
  Params,
  QueryParamsHandling,
  Router,
  RouterModule,
} from "@angular/router";
import {
  LOAD_COMPONENT_QUERY_PARAMS,
  LoadComponentTabIds,
} from "../delivery/loads/loads.component";
import { DateHelper } from "app/utils/date.helper";

interface TabState {
  tab1: boolean;
  tab2: boolean;
  tab3: boolean;
}

interface IumSelect {
  option: number;
  name: string;
}

@Component({
  selector: "app-sales-distribution",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatIcon,
    MatButtonModule,
    NgSelectModule,
    MatDatepickerToggle,
    NgxMatSelectSearchModule,
    FormsModule,
    NgSelectModule,
    MatFormField,
    MatFormFieldModule,
    MatDatepicker,
    MatLabel,
    MatDatepickerModule,
    MatInputModule,
    MatMenu,
    MatMenuModule,
    MatProgressBar,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatTabGroup,
    MatTabsModule,
    MatTab,
    HoverMenuDirective,

    MatExpansionModule,
    MatCheckbox,

    MatTableModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTooltipModule,

    TableListClientComponent,
    TableNoSelectComponent,
    FilterComponent,
    RoutesFiltersComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    DocumentsFiltersComponent,
    BusinessPartnersFiltersComponent,
    DecimalFormatPipe,
    RouterModule,
    PermissionDirective,
    HasPermissionPipe,
  ],
  templateUrl: "./sales-distribution.component.html",
  styleUrl: "./sales-distribution.component.scss",
  providers: [DistributionExport],
})
export class SalesDistributionComponent implements OnDestroy {
  @ViewChild("sortTable1", { static: false }) sortTable1!: MatSort;
  @ViewChild("sortTable2", { static: false }) sortTable2!: MatSort;
  @ViewChild("sortTable4", { static: false }) sortTable4!: MatSort;
  @ViewChildren("sortMultiTable1") sortTables1!: QueryList<MatSort>;
  @ViewChildren("sortMultiTable2") sortTables2!: QueryList<MatSort>;
  @ViewChild(MatMenuTrigger, { static: false })
  menuTrigger: MatMenuTrigger; // Usar MatMenuTrigger
  @ViewChild("updateDialog") updateDialog!: TemplateRef<any>;
  @ViewChild("corfimDialog") confirmDialog!: TemplateRef<any>;
  @ViewChild("alertDialog") alertDialog!: TemplateRef<any>;
  @ViewChild("restartDialog") restartDialog!: TemplateRef<any>;
  @ViewChild("checkDialog") checkDialog!: TemplateRef<any>;
  @ViewChild("infoCard") infoCard!: TemplateRef<any>;
  @ViewChild("excludeDialog") excludeDialog!: TemplateRef<any>;
  @ViewChild("paginatorTable1", { static: false }) paginator!: MatPaginator;
  @ViewChild("paginatorTable2", { static: false }) paginator2!: MatPaginator;
  @ViewChild("paginatorTable3", { static: false }) paginator3!: MatPaginator;
  @ViewChild("paginatorTable4", { static: false }) paginator4!: MatPaginator;
  @ViewChild("tableNoSelectComponent")
  tableNoSelectComponent: TableNoSelectComponent;
  @ViewChild("tableListClientComponent")
  tableListClientComponent: TableListClientComponent;
  @ViewChild("paginationCards", { static: false })
  paginationCards!: MatPaginator;
  @ViewChild("hiddenfileinput") hiddenfileinput!: ElementRef<HTMLInputElement>;
  private isDataLoaded: boolean = true;
  /*
  public filteredCompany: ReplaySubject<CompanyAttributes[]> = new ReplaySubject<
      CompanyAttributes[]
    >(1);
*/

  // Datos user
  public nameUser: string;

  private tableSelect: number;

  public isShowGrap: boolean = false;

  // Screen 1
  public hasAdditionalData: boolean = false;

  private idIndex: string;
  private filterOption: number = 0;
  private dialogActive: boolean = false;
  sortTables = "ASC";

  // Paginacion table 1
  pageSizeTable1: number = 50;
  pageIndexTable1: number = 0;
  totalItemsTable1: number;

  // Paginacion table 2
  pageSizeTable2: number = 50;
  pageIndexTable2: number = 0;
  totalItemsTable2: number;

  // Paginacion table 3
  pageSizeTable3: number = 50;
  pageIndexTable3: number = 0;
  totalItemsTable3: number;

  // Paginacion table 3
  pageSizeTable4: number = 50;
  pageIndexTable4: number = 0;
  totalItemsTable4: number;

  // Paginacion cards
  pageSizeCard: number = 50;
  pageIndexCard: number = 1;
  totalItemsCard: number;
  sortOrder: string = "ASC";
  optionCard: number;
  dialogRefInfo;

  // Datos de las tablas
  // Tabla Screen 1.1
  private materialListSubject = new BehaviorSubject<IMaterialListItem[]>([]);

  public dataSource: MatTableDataSource<IMaterialListItem>;
  private dataTable1: IMaterialListItem[];
  excludeZeros: number = 0;
  listUm = [];
  // Tabla Screen 1.2
  public dataSourceNew = new MatTableDataSource([]);
  private dataTable2: any[];
  private dataStandardTable2: any[];
  private materialListAvalibleSubject = new BehaviorSubject<any[]>([]);
  public isViewMenuOpenScreen1_2 = false;
  public filterSelectScreen1_2 = "Todos";
  // Screen 2
  public dataSourceDistribution: MatTableDataSource<any> | null = null;
  private dataTable3: any[];
  selectedSD: any | null = null;
  public dataSourceItemsDistribution = new MatTableDataSource([]);
  private orderDetails: IOrderDetails[] = [];
  public searchItemDistribution = false;
  public isViewMenuOpen = false;
  public filterSelectDistribution = "Todos";

  // Screen 3
  public dataSourceDelivery: MatTableDataSource<IMaterialListItem>;
  private dataTable4: any[];
  public selectedSDelivery: any | null = null;
  public dataSourceItemsDelivery = new MatTableDataSource([]);
  public checkAllDistribution: boolean = false;

  // Datos Filter
  submitted: boolean = false;
  form: FormGroup;
  materilaList: any = {};
  companyList: CompanyAttributes[] = [];
  routeList: RouteAttributes[] = [];
  routeGroupList: RouteGroupAttributes[] = [];
  materialList;
  salesOfficeList: SalesOfficeAttributes[] = [];
  officeGroupList: OfficeGroupAttributes[] = [];
  materialGruopList: MaterialGroupAttributes[] = [];
  territoyList: RouteAttributes[] = [];
  areaRouteList: RouteAreaAttributes[] = [];
  businessPartnerList: BusinessPartnerAttributes[] = [];
  documentTyoeList: DocumentTypeAttributes[] = [];
  dateTime: Date;

  loadComponentTabIds = LoadComponentTabIds;
  LOAD_COMPONENT_QUERY_PARAMS = LOAD_COMPONENT_QUERY_PARAMS;

  //BUSCADOR
  searchSubscription: Subscription;

  // Data Progress

  selectedOrders = {
    load: 0,
    value: 0,
  };

  noSelectedOrders = {
    load: 0,
    value: 0,
  };

  materialsInProcess = {
    load: 0,
    value: 0,
  };

  selectedCustomers = {
    load: 0,
    value: 0,
  };

  selectedAddress = {
    load: 0,
    value: 0,
  };

  UMPActive: boolean = true;

  private dataInfoCard = [
    {
      title: "Pedidos en espera de carga",
      list: [],
      total: 0,
      totalPages: 0,
    },
    {
      title: "Pedidos en Proceso",
      list: [],
      total: 0,
      totalPages: 0,
    },
    {
      title: "Cliente en Proceso",
      list: [],
      total: 0,
      totalPages: 0,
    },
  ];

  // Data Tabs Screen
  isTabDisable: TabState = {
    tab1: false,
    tab2: true,
    tab3: true,
  };
  selectedTabIndex: number = 0;

  // data table colums
  displayedColumns: string[] = [
    "material",
    "umd", //"umb",
    "ctnUmb",
    "ctnUmp",
  ];
  displayedColumnsNew: string[] = [
    "material",
    "um",
    "cntRequested",
    "cntAvailable",
    "cntNoCovered",
  ];

  displayedColumnsDistributionGeneral: string[] = [
    "det",
    "material",
    "stockRequired",
    "stockCurrent",
    "toFulFill",
    "distribution",
    "tobefulfilled",
    "distributed",
    "option",
  ];

  displayedColumnsDistribution: string[] = [
    "businessParther",
    "price",
    "ctnRequired",
    "ctnProposed",
    "confirmed",
    "toFulFill",
  ];

  displayedColumnsDeliveryGeneral: string[] = ["det", "material", "delivery"];

  displayedColumnsDelivery: string[] = [
    "businessParther",
    "price",
    "ctnRequired",
    "confirmed",
  ];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;
  loadInfoData = false;

  temporalId: string;

  searchQuery: string = "";
  currentStep = 0; // 0 = nada importado, 1 = continuado, 2 = procesando, etc.
  hasProcessed: boolean = false;

  // Permissions Constants
  readonly PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK =
    ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS;

  constructor(
    private authService: AuthService,
    private readonly companyService: CompanyService,
    private readonly saleDistributionService: SalesDistributionService,
    private readonly routeService: SubRouteService,
    private readonly territoryService: RouteService,
    private readonly routeGroupService: RouteGroupService,
    private readonly materiasService: MaterialService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly officeGroupService: OfficeGroupService,
    private readonly materialGroupService: MaterialGroupService,
    private readonly routeAreaService: RouteAreaService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly documentClassService: DocumentClassService,
    private readonly searchService: SearchService,
    private saleDistributionExport: DistributionExport,
    public exportService: ExportService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private readonly permissionService: PermissionService,
    private readonly handlerMessage: HandlerMessageService
  ) {
    //Inicializacion de datos
    this.form = this.fb.group({
      uploadDate: [DateTime.now(), Validators.required],
      companyId: [null],
      salesOfficeGroupId: [[]],
      salesOfficeId: [[]],
      routeGroupId: [[]],
      subRouteId: [[]],
      materialGroupId: [[]],
      materialId: [[]],
      routeId: [[]],
      routeAreaId: [[]],
      customerId: [[]],
      documentClassId: [[]],
      payingBusinessPartnerId: [],
      soldToControl: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit() {
    this.nameUser = this.authService.user.username;
    this.onHandleSearch();
    this.dateTime = new Date(); // Inicializando con la fecha actual
  }

  ngAfterViewInit(): void {
    this.fetchCompanies();
  }

  public onHandleGraph() {
    this.isShowGrap = !this.isShowGrap;

    if (this.isShowGrap) {
      // solo cuando se abre
      const date: Date = this.form.value.uploadDate;
      const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

      const dateFilter = this.cleanObject({
        ...this.form.value,
        uploadDate: dateFormat,
        companyId: this.form.value.companyId,
      });

      // this.fechProductSelect(dateFilter);
      // this.fechDistributionClient(dateFilter);
      // this.fechProductNotSelect({
      //   ...dateFilter,
      //   temporalId: this.temporalId,
      // });

      this.loadInfoData = true;
    }
  }

  public downloadTemplate() {
    if (
      !this.checkIfHasPermission(
        ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.EXPORT,
        "No tienes permisos para descargar la plantilla de distribución de ventas"
      )
    )
      return;
    const url = this.saleDistributionService.getFileTemplateExcel();
    if (!url) {
      this.snackBar.open("Plantilla no disponible.", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    window.open(url);
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.onSearchChange(term);
      }
    );
  }

  public onSearchChange(event: string) {
    const search = event.toLowerCase();

    switch (this.tableSelect) {
      case 1:
        /*
        const dataNew = this.dataTable1.filter((data: IMaterialListItem) => {
          return data?.material?.name.toLowerCase().includes(search);
        });
        this.dataSource.data = dataNew;
        */
        this.findDistribution(
          this.idIndex,
          1,
          this.pageIndexTable1,
          this.pageSizeTable1,
          search,
          0
        );
        break;
      case 2:
        this.findDistribution(
          this.idIndex,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2,
          search,
          this.filterOption
        );
        /*
        const dataNew2 = this.dataTable2.filter((data: any) => {
          return data?.material?.name.toLowerCase().includes(search);
        });
        this.dataSourceNew.data = dataNew2;*/
        break;
      case 3:
        this.findDistribution(
          this.idIndex,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3,
          search,
          this.filterOption
        );
        break;
      /*
        const dataNew3 = this.dataTable3.filter((data: any) => {
          return data?.material.name.toLowerCase().includes(search);
        });
        this.dataSourceDistribution.data = dataNew3;
        */
      case 4:
        this.findDistribution(
          this.idIndex,
          4,
          this.pageIndexTable4,
          this.pageSizeTable4,
          search,
          0
        );
        /*
        const dataNew4 = this.dataTable4.filter((data: any) => {
          return data?.material.name.toLowerCase().includes(search);
        });
        this.dataSourceDelivery.data = dataNew4;*/
        break;
    }
  }

  // Open dialog info Cards
  // public openDialogInfo(option: number) {
  //   this.totalItemsCard = this.dataInfoCard[option].total;
  //   this.pageIndexCard = this.pageIndexCard;

  //   setTimeout(() => {
  //     this.paginationCards.length = this.totalItemsCard;
  //     this.paginationCards.pageIndex = this.pageIndexCard - 1;
  //   });

  //   this.optionCard = option;
  //   this.dialogRefInfo = this.dialog.open(this.infoCard, {
  //     data: {
  //       ...this.dataInfoCard[option],
  //       option,
  //     },
  //     panelClass: "update-modal",
  //     disableClose: true,
  //   });
  // }

  public openDialogInfo(option: number) {
    this.searchQuery = "";
    this.pageIndexCard = 1;
    this.pageSizeCard = 50;
    this.sortTables = "ASC";
    this.dataInfoCard[option].list = [];

    // const date: Date = this.form.value.uploadDate;
    // const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const selectedDate: Date = this.form.value.uploadDate;

    const dataFilter = this.cleanObject({
      ...this.form.value,
      companyId: this.form.value.companyId,
    });

    const dateFilter = this.cleanObject({
      ...this.form.value,
      companyId: this.form.value.companyId,
      pickerUpload_start: selectedDate
        ? DateHelper.getStartOfDay(selectedDate)
        : null,
      pickerUpload_end: selectedDate
        ? DateHelper.getEndOfDay(selectedDate)
        : null,
    });

    this.optionCard = option;

    let request$;

    switch (option) {
      case 0:
        request$ = this.fechProductNotSelect({
          ...dataFilter,
          temporalId: this.temporalId,
        });
        break;
      case 1:
        request$ = this.fechProductSelect({
          ...dateFilter,
        });
        break;
      case 2:
        request$ = this.fechDistributionClient({
          ...dateFilter,
        });
        break;
    }

    request$.subscribe((res: any) => {
      this.dataInfoCard[option].list = res?.data?.data ?? [];
      this.dataInfoCard[option].total = res?.data?.pageInfo?.[0]?.total ?? 0;
      this.dialogRefInfo = this.dialog.open(this.infoCard, {
        data: { ...this.dataInfoCard[option], option },
        panelClass: "update-modal",
        disableClose: true,
        width: "90%",
        maxHeight: "90vh",
      });

      setTimeout(() => {
        this.paginationCards.length = this.dataInfoCard[option].total;
        this.paginationCards.pageIndex = this.pageIndexCard - 1;
      });
    });
  }

  // public servicesFuntion = (sortOrder: string) => {
  //   this.sortOrder = sortOrder;

  //   const date: Date = this.form.value.uploadDate;
  //   const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

  //   const dataFilter = this.cleanObject({
  //     ...this.form.value,
  //     uploadDate: dateFormat,
  //   });

  //   switch (this.optionCard) {
  //     case 0:
  //       this.fechProductNotSelect(dataFilter);
  //       break;
  //     case 1:
  //       this.fechProductSelect(dataFilter);
  //       break;
  //     case 2:
  //       this.fechDistributionClient(dataFilter);
  //       break;
  //   }
  // };

  // public servicesFuntion(sortOrder: string) {
  //   this.sortOrder = sortOrder;
  //   // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

  //   const date: Date = this.form.value.uploadDate;
  //   const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

  //   const dataFilter = this.cleanObject({
  //     ...this.form.value,
  //     uploadDate: dateFormat,
  //   });

  //   switch (this.optionCard) {
  //     case 0:
  //       this.fechProductNotSelect(dataFilter);
  //       break;
  //     case 1:
  //       this.fechProductSelect(dataFilter);
  //       break;

  //     case 2:
  //       this.fechDistributionClient(dataFilter);
  //       break;
  //     default:
  //   }
  // }

  public servicesFuntion = (sortOrder: string, pageIndex: number = 1) => {
    this.sortOrder = sortOrder;
    this.pageIndexCard = pageIndex;

    // const date: Date = this.form.value.uploadDate;
    // const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const selectedDate: Date = this.form.value.uploadDate;

    const dataFilter = this.cleanObject({
      ...this.form.value,
      companyId: this.form.value.companyId,
      pickerUpload_start: selectedDate
        ? DateHelper.getStartOfDay(selectedDate)
        : null,
      pickerUpload_end: selectedDate
        ? DateHelper.getEndOfDay(selectedDate)
        : null,
    });

    const dateFilter = this.cleanObject({
      ...this.form.value,
      companyId: this.form.value.companyId,
    });

    let request$;

    switch (this.optionCard) {
      case 0:
        request$ = this.fechProductNotSelect({
          ...dateFilter,
          temporalId: this.temporalId,
        });
        break;
      case 1:
        request$ = this.fechProductSelect({
          ...dataFilter,
        });
        break;
      case 2:
        request$ = this.fechDistributionClient({
          ...dataFilter,
        });
        break;
    }

    request$.subscribe((res: any) => {
      const newData = res?.data?.data ?? [];

      this.dataInfoCard[this.optionCard].list = newData;

      const pageInfo = res?.data?.pageInfo;
      const total = Array.isArray(pageInfo)
        ? pageInfo[0]?.total
        : pageInfo?.total ?? 0;

      this.dataInfoCard[this.optionCard].total = total;

      this.totalItemsCard = total;
      this.pageIndexCard = 0;

      if (this.tableNoSelectComponent) {
        this.tableNoSelectComponent.updateData(newData);
      }
      if (this.tableListClientComponent) {
        this.tableListClientComponent.updateData(newData);
      }
    });
  };

  // public onPageChangeCardsInfo(event) {
  //   this.pageIndexCard = event.pageIndex + 1;
  //   this.pageSizeCard = event.pageSize;
  //   // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

  //   const date: Date = this.form.value.uploadDate;
  //   const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

  //   const dataFilter = this.cleanObject({
  //     ...this.form.value,
  //     uploadDate: dateFormat,
  //   });
  //   switch (this.optionCard) {
  //     case 0:
  //       this.fechProductNotSelect(dataFilter);
  //       break;
  //     case 1:
  //       this.fechProductSelect(dataFilter);
  //       break;

  //     case 2:
  //       this.fechDistributionClient(dataFilter);
  //       break;
  //     default:
  //   }
  // }

  public onPageChangeCardsInfo(event) {
    this.pageIndexCard = event.pageIndex + 1;
    this.pageSizeCard = event.pageSize;

    this.servicesFuntion(this.sortTables, this.pageIndexCard);
  }

  public onSortChange(sort: Sort, index) {
    const sortColumn = sort.active; // Columna que se está ordenando
    this.sortTables = sort.direction.toUpperCase(); // 'ASC' o 'DESC'

    switch (index) {
      case 1:
        /*
        const dataNew = this.dataTable1.filter((data: IMaterialListItem) => {
          return data?.material?.name.toLowerCase().includes(search);
        });
        this.dataSource.data = dataNew;
        */
        this.findDistribution(
          this.idIndex,
          1,
          this.pageIndexTable1,
          this.pageSizeTable1,
          "",
          0
        );
        break;
      case 2:
        this.findDistribution(
          this.idIndex,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2,
          "",
          this.filterOption
        );
        /*
        const dataNew2 = this.dataTable2.filter((data: any) => {
          return data?.material?.name.toLowerCase().includes(search);
        });
        this.dataSourceNew.data = dataNew2;*/
        break;
      case 3:
        this.findDistribution(
          this.idIndex,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3,
          "",
          this.filterOption
        );
        break;
      /*
        const dataNew3 = this.dataTable3.filter((data: any) => {
          return data?.material.name.toLowerCase().includes(search);
        });
        this.dataSourceDistribution.data = dataNew3;
        */
      case 4:
        this.findDistribution(
          this.idIndex,
          4,
          this.pageIndexTable4,
          this.pageSizeTable4,
          "",
          0
        );
        /*
        const dataNew4 = this.dataTable4.filter((data: any) => {
          return data?.material.name.toLowerCase().includes(search);
        });
        this.dataSourceDelivery.data = dataNew4;*/
        break;
    }
  }

  private asignarSortsTable1_1() {
    if (this.sortTable1) {
      this.dataSource.sort = this.sortTable1;
    }
  }

  private assignSortMultiTable1() {
    this.sortTables1.forEach((sort, index) => {
      if (this.dataSourceDistribution[index]?.items) {
        this.dataSourceDistribution[index].items.sort = sort;
      }
    });
  }

  public closeMenu() {
    this.menuTrigger.closeMenu();
  }

  public compareById = (o1: any, o2: any) => o1 && o2 && o1._id === o2._id;

  public onChangeActive(item) {
    if (item.selected == null) {
      item.selected = 1;
    }

    this.fechUmActive(item.selected, item.material._id);
  }

  /**
   * When the "U.M. Distribución" select opens, consult the product master to
   * read the configured distribution unit of measure and disable every option
   * that is not the configured one. A tooltip tells the user to change it in
   * the product master. The flow is never blocked: on error or when no unit is
   * configured, all options stay enabled.
   */
  public onOpenUmd(item: IMaterialListItem): void {
    const materialId = item?.material?._id;
    if (!materialId) {
      return;
    }

    this.materiasService.findOne(materialId).subscribe({
      next: (res) => {
        const raw = res?.data?.distributionUnitOfMeasure;
        const configured: IUnitOfMeasure | undefined = raw
          ? {
              _id: String(raw._id ?? ""),
              code: raw.code ?? "",
              name: raw.name ?? "",
            }
          : undefined;
        this.applyUmdRestriction(item, configured);
      },
      error: () => {
        // Leave the options untouched so the assistant flow is not blocked.
      },
    });
  }

  /**
   * Locks the U.M. select to the product master's configured distribution unit.
   *
   * Rule (mirrors the backend in distribution-stock.service.ts): the master's
   * `distributionUnitOfMeasure` is always either the base or the parallel unit.
   * When it matches the parallel unit the allowed option is 2, otherwise 1.
   * Every other option is disabled with a tooltip telling the user to remove
   * the configured unit in the master if they need a different one.
   *
   * When the master has NO configured distribution unit, the choice is free and
   * every option stays enabled.
   */
  private applyUmdRestriction(
    item: IMaterialListItem,
    configured: IUnitOfMeasure | undefined
  ): void {
    const options: IUmOption[] = item?.listUm ?? [];
    const configuredId = configured?._id;
    const configuredCode = configured?.code;

    // No configured distribution unit in the master → free choice.
    if (!configuredId && !configuredCode) {
      item.listUm = options.map((opt) => ({
        ...opt,
        disabled: false,
        umdTooltip: "",
      }));
      return;
    }

    // The configured unit is the parallel one (option 2) when it matches the
    // parallel unit by id/code; otherwise it resolves to the base unit (1).
    const parallel: IUnitOfMeasure | undefined = item?.pararellUnitOfMeasure;
    const matchesParallel =
      !!parallel &&
      ((!!configuredId && parallel._id === configuredId) ||
        (!!configuredCode && parallel.code === configuredCode));
    const allowedOption = matchesParallel ? 2 : 1;

    const tooltip =
      "Este material tiene una unidad de distribución configurada en el maestro. " +
      "Para usar otra se debe de configurar en el maestro del material.";

    item.listUm = options.map((opt) => {
      const enabled = opt.option === allowedOption;
      return {
        ...opt,
        disabled: !enabled,
        umdTooltip: enabled ? "" : tooltip,
      };
    });
  }

  // CheckBox opcion de medida
  public onChangeUMP(event: MatCheckboxChange, item) {
    item.isUMB = !event.checked;
    item.isUMP = event.checked;

    if (item.isUMP) {
      this.fechUmActive(1, item.material._id);
    } else {
      this.fechUmActive(0, item.material._id);
    }
  }

  public onChangeUMB(event: MatCheckboxChange, item) {
    item.isUMP = !event.checked;
    item.isUMB = event.checked;

    if (item.isUMP) {
      this.fechUmActive(2, item.material._id);
    } else {
      this.fechUmActive(1, item.material._id);
    }
  }

  // Comparacion

  private createdDataSecondTable(dataNew: Array<any>) {
    let calculate = 0;
    const newData = dataNew.map((item) => {
      if (item.selected === 1) {
        calculate = item.TotalBaseQuantity - item.availableQuantity;
      } else {
        calculate = item.TotalPararellQuantity - item.availableQuantityPararell;
      }

      return {
        ...item,
        cntNoCovered: calculate < 0 ? 0 : calculate,
      };
    });
    return newData;
  }

  // Handle obtener archivo Excel
  public handleFileInput = (event: Event) => {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0]; // Obtiene el primer archivo seleccionado

      // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

      const date: Date = this.form.value.uploadDate;
      const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

      const dataFilter = this.cleanObject({
        ...this.form.value,
        uploadDate: dateFormat,
        temporalId: this.idIndex,
      });
      this.openDialogCount(file, dataFilter);

      input.value = "";
      // Avanzar al paso siguiente para mostrar botón "Continuar"
      this.currentStep = 1;
    }
  };

  private fetchCompanyFilter(): void {
    if (this.companyList.length === 1) {
      this.form.get("companyId").setValue(this.companyList[0]._id);
    }
  }

  // Limpiar Filtro
  public handleFilterClean() {
    this.form.reset({
      uploadDate: new Date(),
      companyId: null,
      salesOfficeGroupId: [],
      salesOfficeId: [],
      routeGroupId: [],
      subRouteId: [],
      materialGroupId: [],
      materialId: [],
      routeId: [],
      routeAreaId: [],
      customerId: [],
      documentClassId: [],
    });
    this.dialog.closeAll();
    this.dialogRefInfo = null;
    this.fetchCompanyFilter();

    // this.rebootInit();
  }

  private rebootInit() {
    this.dataSource.data = [];

    this.selectedOrders.value = 0;
    this.materialsInProcess.value = 0;
    this.selectedCustomers.value = 0;
    this.selectedAddress.value = 0;
    this.selectedOrders.load = 0;
    this.materialsInProcess.load = 0;
    this.selectedCustomers.load = 0;
    this.selectedAddress.load = 0;
    this.reboot();

    // Resetear el paso para ocultar el botón de reinicio
    this.currentStep = 0;
    this.hasProcessed = false;
  }

  public rebootDistribution() {
    this.reboot();

    this.materialsInProcess.value = this.dataSource.data.length;

    this.selectedOrders.load = 0;
    this.materialsInProcess.load = 0;
    this.selectedCustomers.load = 0;
    this.selectedAddress.load = 0;

    // Resetear el paso para ocultar el botón de reinicio
    this.currentStep = 0;
    this.hasProcessed = false;
  }

  private reboot() {
    this.dataSourceNew.data = [];
    this.dataSourceItemsDistribution.data = [];
    this.dataSourceItemsDelivery.data = [];
    this.orderDetails = [];
    this.checkAllDistribution = false;

    this.isTabDisable = {
      tab1: false,
      tab2: true,
      tab3: true,
    };
    this.selectedTabIndex = 0;

    this.hasAdditionalData = false;
  }
  // Pasar datos
  public handleNext = () => {
    // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

    const date: Date = this.form.value.uploadDate;
    const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const dateFilter = this.cleanObject({
      ...this.form.value,
      uploadDate: dateFormat,
      temporalId: this.idIndex,
      ExcludeZeros: this.excludeZeros.toString(),
    });
    this.fetchDistrubution(dateFilter, this.dataStandardTable2);
  };

  // Agrupar por nombre

  private groupByName(): Array<any> {
    const groupedData: any = {};

    // Agrupar los datos por el campo 'name'
    this.dataSourceNew.data.forEach((item) => {
      if (!groupedData[item.material.name]) {
        groupedData[item.material.name] = [];
      }
      groupedData[item.material.name].push({
        ...item,
        proposed: 12,
      });
    });

    // Convertir el objeto agrupado a un array de objetos planos
    const groupedArray = [];
    for (const name in groupedData) {
      if (groupedData.hasOwnProperty(name)) {
        // Crear un objeto que contiene el nombre y el array de items del grupo

        groupedArray.push({
          items: new MatTableDataSource(groupedData[name]),
          name: name,
          distribution: 0,
          porcent: 0,
          code: groupedData[name][0].material?.code,
          um: groupedData[name][0].baseUnitOfMeasure?.code,
        });
      }
    }

    // Crear y retornar un MatTableDataSource con el array de datos agrupados
    return groupedArray;
  }

  // Definición de la función formatZero
  public formatZero(value: any): string | number {
    if (value) {
      if (typeof value != "string") {
        return value === 0 ? "-" : value.toFixed(3);
      }
    }

    return "-";
  }

  public handleViewScreen1_2(option) {
    switch (option) {
      case 3:
        this.filterOption = 2;
        this.findDistribution(
          this.idIndex,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2,
          "",
          this.filterOption
        );
        /*
      const dataProgressDis = this.dataTable2.filter((data: any) => {
          return data?.cntNoCovered > 0;
        });*/
        this.filterSelectDistribution = "No cubierto";

        //  this.dataSourceNew.data = dataProgressDis;
        this.materialsInProcess.value = this.dataSourceNew.data.length;
        break;
      case 2:
        /*  
      const dataFinishDis = this.dataTable2.filter((data: any) => {
          return data?.cntNoCovered === 0;
        });*/
        this.filterOption = 1;
        this.filterSelectDistribution = "Cubierto";
        this.findDistribution(
          this.idIndex,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2,
          "",
          this.filterOption
        );
        //  this.dataSourceNew.data = dataFinishDis;
        this.materialsInProcess.value = this.dataSourceNew.data.length;
        break;
      default:
        this.filterOption = 0;
        this.filterSelectDistribution = "Todo";
        this.findDistribution(
          this.idIndex,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2,
          "",
          this.filterOption
        );
        //  this.dataSourceNew.data = this.dataTable2;
        this.materialsInProcess.value = this.dataSourceNew.data.length;
        break;
    }
  }

  // Pantalla dos

  toggleDetails(dataSelect: any): void {
    if (
      this.selectedSD &&
      this.selectedSD?.material?.code === dataSelect?.material?.code
    ) {
      this.selectedSD = null;
      this.searchItemDistribution = false;
      this.onHandleSearchDistibution(null);
      return;
    }

    this.selectedSD = dataSelect;

    this.dataSourceItemsDistribution.data = this.selectedSD?.orderList || [];

    this.dataSourceItemsDistribution.sortingDataAccessor = (
      data: any,
      headerId: string
    ) => {
      switch (headerId) {
        case "businessParther":
          return data.shipTo?.name?.toLowerCase() || "";
        case "price":
          return data.unitPrice || 0;
        case "ctnRequired":
          return data.baseQuantity || 0;
        case "ctnProposed":
          return data.soldQuantitySuggested || 0;
        case "confirmed":
          return data.confirmed || 0;
        case "toFulFill":
          return data.porcentCompleted || 0;
        default:
          return "";
      }
    };
    /*
          setTimeout(() => {
          this.asignarSortsTable1_1();
        });

        */
  }

  public searchDistributionActive() {
    this.searchItemDistribution = !this.searchItemDistribution;
  }

  public onHandleSearchDistibution(event: any) {
    const search =
      (event?.target as HTMLInputElement)?.value.trim().toLowerCase() ?? "";
    const dataNew = this.selectedSD?.orderList.filter((data: any) => {
      return data?.shipTo?.name.toLowerCase().includes(search);
    });
    this.dataSourceItemsDistribution.data = dataNew;
  }

  public handleViewDistribution(option) {
    switch (option) {
      case 3:
        /* const dataProgressDis = this.dataTable3.filter((data: any) => {
          return data?.toFulFill > 0;
        });
        */
        this.filterOption = 2;
        this.findDistribution(
          this.idIndex,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3,
          "",
          this.filterOption
        );
        this.filterSelectDistribution = "No Cumplido";
        //this.dataSourceDistribution.data = dataProgressDis;
        this.materialsInProcess.value = this.dataSourceDistribution.data.length;
        break;
      case 2:
        this.filterOption = 1;
        this.findDistribution(
          this.idIndex,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3,
          "",
          this.filterOption
        );
        /* 
      const dataFinishDis = this.dataTable3.filter((data: any) => {
          return data?.toFulFill === 0;
        });*/
        this.filterSelectDistribution = "Cumplido";
        //this.dataSourceDistribution.data = dataFinishDis;
        this.materialsInProcess.value = this.dataSourceDistribution.data.length;
        break;
      default:
        this.filterOption = 0;
        this.findDistribution(
          this.idIndex,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3,
          "",
          this.filterOption
        );
        this.filterSelectDistribution = "Todo";
        // this.dataSourceDistribution.data = this.dataTable3;
        this.materialsInProcess.value = this.dataSourceDistribution.data.length;
        break;
    }

    const allChecked = this.dataSourceDistribution.data.every(
      (item) => item.isChecked
    );

    if (allChecked) {
      this.checkAllDistribution = true;
    } else {
      this.checkAllDistribution = false;
    }
  }

  public onChangeProgressDistribution(item: any) {
    const totalConfirmed = this.selectedSD.orderList.reduce(
      (sum: any, item: any) => sum + (item.confirmed || 0),
      0
    );

    const totalProposed = this.dataSourceItemsDistribution.data.reduce(
      (sum: any, item: any) => sum + (item.soldQuantitySuggested || 0),
      0
    );
    // Porcentaje  distribuido sugerido
    const progress = (totalConfirmed * 100) / totalProposed;
    // Actualizacion general
    this.selectedSD.distribution = totalConfirmed || 0;
    this.selectedSD.porcentDistribuite = progress || 0;
    this.selectedSD.toFulFill =
      this.selectedSD.stockRequest - this.selectedSD.distribution;

    // Porcentaje por cumplir al 100 porciento
    const tobefulfilled =
      (this.selectedSD.distribution * 100) / this.selectedSD.stockRequest;

    this.selectedSD.porcentCompleted = tobefulfilled ?? 0;

    // Actulizacion item porcentafe distribuido
    const porcentItem = (item.confirmed * 100) / item.baseQuantity;
    item.porcentCompleted = porcentItem || 0;

    // Porcentaj productos cargados
  }

  // Validar Input

  public validateInput(event: any, subData) {
    let value = event.target.value;

    // Permite solo números con máximo 2 decimales
    value = value.replace(/[^0-9.]/g, ""); // Elimina caracteres no numéricos
    value = value.replace(/(\..*?)\..*/g, "$1"); // Evita más de un punto decimal
    value = value.replace(/^0+(\d)/, "$1"); // Elimina ceros innecesarios al inicio
    value = value.replace(/^(\d+)(\.\d{0,3})?.*$/, "$1$2");

    let numericValue = parseFloat(value);

    let sumConfirmedOthers = this.dataSourceItemsDistribution.data
      .filter((s) => s !== subData) // excluir el actual
      .map((s) => s.confirmed ?? 0)
      .reduce((a, b) => a + b, 0);
    // Ajustá la distribución temporalmente quitando lo que este input ya tenía
    let allow = Math.min(
      this.selectedSD.stockCurrent - sumConfirmedOthers,
      subData?.baseQuantity ?? this.selectedSD.stockCurrent
    );

    allow = subData?.baseQuantity > allow ? allow : subData?.baseQuantity;

    if (numericValue > allow && numericValue) {
      numericValue = parseFloat(allow.toFixed(3)) ?? 0;
    }

    // Actualiza el input con el valor corregido
    event.target.value = numericValue;
    subData.confirmed = numericValue;

    this.onChangeProgressDistribution(subData);
  }

  public onPageChangeTable1(event) {
    this.pageIndexTable1 = event.pageIndex;
    this.pageIndexTable1 = event.pageIndex;

    this.findDistribution(
      this.idIndex,
      1,
      this.pageIndexTable1,
      this.pageSizeTable1
    );
  }

  public onPageChangeTable2(event) {
    this.pageIndexTable2 = event.pageIndex;
    this.pageIndexTable2 = event.pageIndex;

    this.findDistribution(
      this.idIndex,
      2,
      this.pageIndexTable2,
      this.pageSizeTable2,
      "",
      this.filterOption
    );
  }

  public onPageChangeTable3(event) {
    this.pageIndexTable3 = event.pageIndex;
    this.pageIndexTable3 = event.pageIndex;

    this.findDistribution(
      this.idIndex,
      3,
      this.pageIndexTable3,
      this.pageSizeTable3,
      "",
      this.filterOption
    );
  }

  public onPageChangeTable4(event) {
    this.pageIndexTable4 = event.pageIndex;
    this.pageIndexTable4 = event.pageIndex;

    this.findDistribution(
      this.idIndex,
      4,
      this.pageIndexTable4,
      this.pageSizeTable4,
      "",
      0
    );
  }

  private addItemOrderList(item: any, id?: string, check?: boolean) {
    const updateOrder = this.orderDetails.find((order) => {
      return (
        order.orderId === item.orderId &&
        order.position === item.orderDetailPosition
      );
    });

    if (updateOrder) {
      if (updateOrder.isCheck || check) {
        updateOrder.quantity = item.confirmed;
        updateOrder.isCheck = true;
        item.isChecked = true;
      }
    } else {
      this.orderDetails.push({
        orderId: item.orderId,
        position: item.orderDetailPosition,
        quantity: 0,
        temporalId: this.idIndex,
        materialId: id,
        isCheck: false,
      });
    }
  }

  private deleteteItemOrderList(item: any) {
    this.orderDetails = this.orderDetails.map((order) => {
      return {
        ...order,
        quantity: 0,
        isCheck: false,
      };
    });
  }

  private onChangeCheckboxConfirmed(event: MatCheckboxChange, item: any) {
    if (event.checked) {
      this.addItemOrderList(item, "", event.checked);
    } else {
      this.deleteteItemOrderList(item);
    }
  }

  public onChangeCheckboxConfirmedItem(event: MatCheckboxChange, item: any) {
    this.onChangeCheckboxConfirmed(event, item);

    const allChecked = this.selectedSD.orderList.every(
      (item) => item.isChecked
    );

    if (allChecked) {
      this.selectedSD.isChecked = true;
    } else {
      this.selectedSD.isChecked = false;
    }
  }

  public onChangeCheckboxConfirmedGeneral(event: MatCheckboxChange, data: any) {
    if (event.checked) {
      data.orderList.forEach((item) => {
        this.addItemOrderList(item, "", event.checked);
        item.isChecked = true;
      });
    } else {
      data.orderList.forEach((item) => {
        this.deleteteItemOrderList(item);
        item.isChecked = false;
      });
    }

    const allChecked = this.dataSourceDistribution.data.every(
      (item) => item.isChecked
    );

    if (allChecked) {
      this.checkAllDistribution = true;
    } else {
      this.checkAllDistribution = false;
    }
  }

  public onChangeCheckboxConfirmedAll(action) {
    if (action) {
      this.dataSourceDistribution.data.forEach((order) => {
        order.isChecked = true;
        order.orderList.forEach((item) => {
          this.addItemOrderList(item, "", action);
          item.isChecked = true;
        });
      });
    } else {
      this.dataSourceDistribution.data.forEach((order) => {
        order.isChecked = false;
        order.orderList.forEach((item) => {
          this.deleteteItemOrderList(item);

          item.isChecked = false;
        });
      });
    }
  }

  public handleTab3 = (next) => {
    // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

    const date: Date = this.form.value.uploadDate;
    const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const dataFilter = this.cleanObject({
      ...this.form.value,
      uploadDate: dateFormat,
      temporalId: this.idIndex,
    });
    this.fetchOrderSaveDistribution(next, dataFilter);
  };

  // Dialogs

  public openDialogCheck(event: MatCheckboxChange) {
    this.dialog
      .open(this.checkDialog, {
        data: {
          title: event.checked
            ? "Aceptar Distribución"
            : "Rechazar Distribución",
          description: event.checked
            ? "¿Está seguro de que desea aceptar todas las distribuciones?"
            : "¿Está seguro de que desea rechazar todas las distribuciones? ",
        },
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) =>
        result
          ? this.onChangeCheckboxConfirmedAll(event.checked)
          : (this.checkAllDistribution = !event.checked)
      );
  }

  public openDialogSave(next: boolean) {
    if (
      !this.checkIfHasPermission(
        ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.CREATE,
        "No tienes permisos para guardar la distribución de ventas"
      )
    )
      return;
    const unconfirmedItems = this.dataSourceDistribution.data
      .map((material) => ({
        materialName: material.material?.name,
        orders: material.orderList.filter((i) => !i.isChecked),
      }))
      .filter((mat) => mat.orders.length > 0);

    this.dialog
      .open(this.updateDialog, {
        data: {
          title: "Guardar Distribución",
          unconfirmedItems,
        },
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          if (next) {
            this.handleTab3(next);
          } else {
            this.fetchOrderSaveDistribution(next);
          }

          // Marcar como procesado solo después de que confirme
          this.hasProcessed = true;
        }
      });
  }

  public openDialogAlert(number: string) {
    this.dialog.open(this.alertDialog, {
      data: {
        title: "Pedidos en espera de carga",
        description:
          "Hay " +
          number +
          " pedidos pendientes que no tienen una fecha de carga asignada.",
      },
      panelClass: "update-modal",
      disableClose: true,
      autoFocus: false,
      restoreFocus: false,
    });
  }

  public openDialogAlertRestart() {
    if (
      !this.checkIfHasPermission(
        ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.CREATE,
        "No tienes permisos para reiniciar la distribución de ventas"
      )
    )
      return;
    this.dialog
      .open(this.restartDialog, {
        data: {
          title: "Reinicio",
          description: "¿Desea iniciar desde cero?",
        },
        panelClass: "update-modal",
        disableClose: true,
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe((result) =>
        result ? this.rebootInit() : this.rebootDistribution()
      );
  }

  // Dialogs

  private openDialogCount(file: File, dataFilter: any) {
    this.dialog
      .open(this.excludeDialog, {
        data: {
          title: "Información selecionada",
          description:
            "¿Desea considerar únicamente los materiales reportados en el archivo para la distribución presente?",
        },
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.excludeZeros = 1;
        } else {
          this.excludeZeros = 0;
        }
        this.fetchOrderAvalible(file, {
          ...dataFilter,
          ExcludeZeros: this.excludeZeros.toString(),
        });
      });
  }

  // Pantalla 3

  public openDialogConfirm() {
    this.dialog
      .open(this.confirmDialog, {
        data: {},
        panelClass: "update-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe();
  }

  //Advertencia buscar de nuevo

  public openDialogAlestReset() {
    this.dialog
      .open(this.restartDialog, {
        data: {
          title: "Reiniciar datos",
          description: "¿Está seguro de reiniciar los datos?",
        },
        panelClass: "update-modal",
        disableClose: true,
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.rebootInit();
          this.searhFilter();
        }
      });
  }

  toggleDetailsDelivery(dataSelect: any): void {
    if (
      this.selectedSDelivery &&
      this.selectedSDelivery.material.code === dataSelect.material.code
    ) {
      this.closeDetailsDelivery();
      return;
    }

    this.selectedSDelivery = dataSelect;

    this.dataSourceItemsDelivery.data = this.selectedSDelivery?.orderList || [];
  }

  closeDetailsDelivery(): void {
    this.selectedSDelivery = null;
  }

  public handleTab1 = () => {
    this.dataSourceDistribution = new MatTableDataSource([]);

    // Crear nuevos objetos para romper referencias
    const newData = this.dataSourceNew.data.map((data) => ({
      ...data,
      confirmed: 0, // Resetear valor que controla el checkbox
    }));

    this.dataSourceNew = new MatTableDataSource([...newData]);

    this.isTabDisable = {
      tab1: false,
      tab2: true,
      tab3: true,
    };
    this.selectedTabIndex = 0;
  };

  // Screen 3
  public handleExportAll(): void {
    if (
      !this.checkIfHasPermission(
        ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.EXPORT,
        "No tienes permisos para exportar la distribución de ventas"
      )
    )
      return;
    this.exportData("total");
  }

  public handleExportSummary(): void {
    this.exportData("resume");
  }

  private exportData(option): void {
    const id = "sales-distribution";
    /*
    if (this.exportService.taskIsActive(id)) {
      this.exportService.setVisible(true);
      return;
    }

      const dataFilter = buildQuery<any>(
      where(<any>"company.id", Ops.in(...[""]))
    );
*/
    if (!this.saleDistributionExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: SALE_DISTRIBUTION_EXPORT_TITLE,
      },
    });

    // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;

    const date: Date = this.form.value.uploadDate;
    const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const dateFilter: IOptionFilterDistribution = {
      id: this.idIndex,
      indexPage: this.pageIndexTable4 + 1,
      limit: this.pageSizeTable4,
      sort: this.sortTables,
      search: "",
      state: 0,
    };

    this.cleanObject({
      ...this.form.value,
      uploadDate: dateFormat,
      temporalId: this.idIndex,
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      let dataSize = 0;

      this.dataSourceDelivery.data.forEach((item: any) => {
        dataSize += item.orderList.length;
      });

      if (options) {
        /*
         this.exportService
          .createForSalesDistribution(
            dataSize,
            dataFilter,
            dateFilter,
            options.range,
            options.format,
            option
          )
          .start();
        
        */

        this.saleDistributionExport.export(
          options.format,
          options.range ?? 0,
          dataSize,
          this.pageSizeTable4,
          this.pageIndexTable4 + 1,
          dateFilter
        );
      }
    });
  }

  // Data filter

  // Filter onChange Company
  public onSelectionChangeSalesGroup(): void {
    this.fetchAllSalesOffice();
  }

  public onSelectionChangeGroupRoutes(): void {
    this.fetchAllRoute();
  }

  public onSelectionChangeMaterialsGroup(): void {
    this.fetchMaterials();
  }

  public onSelectionTerritory(): void {
    this.fetchAllTerritory();
    this.fetchAllAreaRoute();
  }

  // Aplicar
  public handleFilterSearch(): void {
    this.submitted = true;
    if (this.form.valid) {
      if (this.dataSourceDistribution && this.dataSourceDistribution?.data.length > 0) {
        this.openDialogAlestReset();
      } else {
        this.searhFilter();
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  private searhFilter() {
    // const dateFormat = `${this.form.value.uploadDate.c.year}-${this.addZero(this.form.value.uploadDate.c.month)}-${this.addZero(this.form.value.uploadDate.c.day)}`;
    const date: Date = this.form.value.uploadDate;
    const dateFormat = `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;

    const dateFilter = this.cleanObject({
      ...this.form.value,
      uploadDate: dateFormat,
      companyId: this.form.value.companyId,
    });
    this.dialog.closeAll();
    this.dialogRefInfo = null;

    this.feachMaterial(dateFilter);
  }

  // format add cero
  private addZero(value: number) {
    return value < 10 ? `0${value}` : value;
  }

  // Eliminar arrays vacions
  private cleanObject(obj: IFilterMaterial) {
    // Itera sobre las claves del objeto
    for (let key in obj) {
      // Si el valor es un array vacío, elimina la clave
      if (Array.isArray(obj[key]) && obj[key].length === 0) {
        delete obj[key];
      }
    }
    return obj;
  }

  // POrcentage de productos cargados
  private advanceProductLoad() {
    const stockRequest = this.dataSourceDistribution.data.reduce(
      (sum: number, item: any) => {
        const valor = item.stockRequest || 0; // Asegurar que porcent no sea undefined

        return sum + valor;
      },
      0 // Valor inicial del acumulador
    );

    const quantity = this.orderDetails.reduce(
      (sum: number, item: any) => {
        const valor = item.quantity || 0; // Asegurar que porcent no sea undefined

        return sum + valor;
      },
      0 // Valor inicial del acumulador
    );

    const porcentGeneral = (quantity * 100) / stockRequest;

    this.materialsInProcess.load = porcentGeneral;
  }

  // Feach de datos (API)

  // Obtencion de los datos del Filtro

  // Fetch companies
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      if (res.data.length === 1) {
        this.form.get("companyId").setValue(res.data[0]._id);
        this.handleFilterSearch();
      }
    });
  }

  // Fetch Rutas
  private fetchAllRoute(): void {
    this.routeService
      .findToComboBoxByGroup(this.form.value.routeGroupId)
      .subscribe({
        next: (res) => {
          this.routeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener rutas.",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  // Feach Materials

  private fetchMaterials(): void {
    this.materiasService
      .findToComboBoxByGroup(this.form.value.materialGroupId)
      .subscribe((res) => {
        this.materialList = res.data;
      });
  }

  // Fetch Oficina de ventas
  private fetchAllSalesOffice(): void {
    this.salesOfficeService
      .findToComboBoxGroup(this.form.value.salesOfficeGroupId)
      .subscribe({
        next: (res) => {
          this.salesOfficeList = res.data;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al obtener oficinas de ventas",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  private fetchAllTerritory(): void {
    this.territoryService.findToComboBox(this.form.value.companyId).subscribe({
      next: (res) => {
        this.territoyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener territorios.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private fetchAllAreaRoute(): void {
    this.routeAreaService.findToComboBox(this.form.value.companyId).subscribe({
      next: (res) => {
        this.areaRouteList = res.data;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener areas de rutas.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  // Datos de la tab 1 importacion tabla 1
  private resultScreen1_1(data: any) {
    this.dataTable1 = data.materialList
      .filter(
        (dataM: IMaterialListItem) => dataM !== null && dataM !== undefined
      )
      .map((dataM: any) => {
        const umb = dataM?.baseUnitOfMeasure
          ? { name: dataM?.baseUnitOfMeasure.code, option: 1 }
          : null;
        const ump = dataM?.pararellUnitOfMeasure
          ? { name: dataM?.pararellUnitOfMeasure.code, option: 2 }
          : null;
        const listUm = [];

        if (umb != null) {
          listUm.push(umb);
        }

        if (ump != null) {
          listUm.push(ump);
        }

        return {
          ...dataM,
          TotalPararellQuantity: this.formatZero(dataM?.TotalPararellQuantity),
          listUm,
        };
      });

    if (this.UMPActive && this.dataTable1.length > 0) {
    }

    this.dataSource = new MatTableDataSource(this.dataTable1);
    this.selectedOrders.value = data.selectedOrders;
    this.materialsInProcess.value = this.dataTable1.length;
    this.selectedCustomers.value = data.selectedCustomers;
    this.selectedAddress.value = data.selectedAddress;

    this.tableSelect = 1;
    /*
    this.dataSource.sortingDataAccessor = (data: any, headerId: string) => {
      switch (headerId) {
        case "material":
          return data.material?.name?.toLowerCase() || "";
        case "um":
          return data.baseUnitOfMeasure?.code?.toLowerCase() || "";
        case "ctnUmb":
          return data.TotalBaseQuantity || 0;
        case "ctnUmp":
          return data.TotalPararellQuantity || 0;
        default:
          return "";
      }
    };

    setTimeout(() => {
      this.asignarSortsTable1_1();
    });*/
  }

  //Datos de la tab 1 importacion table 2
  private resultScreen1_2(res: any) {
    this.dataStandardTable2 = res.data;

    const screen1_2 = this.createdDataSecondTable(res.data.materialList);
    this.dataTable2 = screen1_2;

    this.materialListAvalibleSubject.next(this.dataTable2);

    this.dataSourceNew = new MatTableDataSource(
      this.materialListAvalibleSubject.value
    );
    this.hasAdditionalData = true;

    this.tableSelect = 2;

    this.materialsInProcess.value = this.dataTable2.length;
    /*
    this.dataSourceNew.sortingDataAccessor = (data: any, headerId: string) => {
      switch (headerId) {
        case "material":
          return data.material?.name?.toLowerCase() || "";
        case "um":
          return data.baseUnitOfMeasure?.code?.toLowerCase() || "";
        case "cntRequested":
          return data.TotalBaseQuantity || 0;
        case "cntAvailable":
          return data.availableQuantity || 0;
        case "cntNoCovered":
          return data.cntNoCovered || 0;
        default:
          return "";
      }
    };
    setTimeout(() => {
      this.asignarSortsTable1_2();
    });
*/
    this.totalItemsTable2 = res?.totalItems;

    setTimeout(() => {
      if (this.paginator2) {
        this.paginator2.length = this.totalItemsTable2;
      }
    }, 0);
  }

  // Datos de la tab2 disribucion
  private resultScreen2(res: any) {
    this.dataTable3 = res.data.materialList.map((material: any) => {
      var countCheck = 0;
      const result = material.orderList.reduce(
        (acc, item) => {
          acc.baseQuantity += item.baseQuantity;
          acc.soldQuantitySuggested += item.soldQuantitySuggested;
          item.confirmed = item.soldQuantitySuggested ?? 0;
          acc.confirmedTotal += item.confirmed;
          item.porcentCompleted =
            (item.soldQuantitySuggested * 100) / item.baseQuantity;

          this.addItemOrderList(item, material.material._id);
          item?.isChecked && countCheck++;
          /*
          this.orderDetails.push({
            orderId: item.orderId,
            position: item.orderDetailPosition,
            quantity: 0,
            temporalId: this.idIndex,
            materialId: item._id,
          });
*/
          return acc;
        },
        { baseQuantity: 0, soldQuantitySuggested: 0, confirmedTotal: 0 } // Inicializamos los valores en 0
      );
      if (countCheck === material.orderList.length) {
        material.isChecked = true;
      }
      const toFulFill = result.baseQuantity - result.soldQuantitySuggested;
      const porcentCompleted =
        (result.soldQuantitySuggested * 100) / result.confirmedTotal; //TO DO consultar a CRIS sobre este cambio cambiar confirmedTotal por baseQuantity
      return {
        ...material,

        distribution: result.soldQuantitySuggested,
        porcentCompleted,
        porcentDistribuite: porcentCompleted,
        stockRequest: result.baseQuantity,
        stockCurrent: result.soldQuantitySuggested,
        toFulFill: toFulFill <= 0 ? 0 : toFulFill,
      };
    });

    this.selectedOrders.load = 100;
    this.materialsInProcess.value = this.dataTable3.length;

    this.selectedCustomers.load = 100;
    this.selectedAddress.load = 100;

    this.dataSourceDistribution = new MatTableDataSource(this.dataTable3);
    this.assignSortMultiTable1();
    this.recalculateDistributionOnLoad();
    this.tableSelect = 3;

    // Cambio de tab segundo
    this.isTabDisable = {
      tab1: true,
      tab2: false,
      tab3: true,
    };
    this.selectedTabIndex = 1;
    this.hasAdditionalData = false;

    this.totalItemsTable3 = res?.totalItems;

    setTimeout(() => {
      if (this.paginator3) {
        this.paginator3.length = this.totalItemsTable3;
      }
    }, 0);
  }

  public recalculateDistributionOnLoad(): void {
    if (!this.dataSourceDistribution || !this.dataSourceDistribution.data)
      return;

    this.dataSourceDistribution.data.forEach((material) => {
      let materialConfirmed = 0;
      let materialBaseTotal = 0;

      material.orderList.forEach((item) => {
        if (item.confirmed == null)
          item.confirmed = item.soldQuantitySuggested ?? 0;

        // % por item
        item.porcentCompleted =
          (item.confirmed * 100) / (item.baseQuantity || 1);

        materialConfirmed += item.confirmed;
        materialBaseTotal += item.baseQuantity ?? 0;
      });

      // % por material
      material.porcentCompleted =
        (materialConfirmed * 100) / (materialBaseTotal || 1);
    });
    this.dataSourceDistribution.data = [...this.dataSourceDistribution.data];
  }

  // Tab 3 tabla de entrega
  private resultScreen3(res: any) {
    this.dataTable4 = res.data.materialList.map((item: any) => {
      const atend = item.orderList.reduce((sum: number, item: any) => {
        const valor = item.soldQuantitySuggested || 0;

        return sum + valor;
      }, 0);

      return {
        ...item,
        delivery: atend,
      };
    });
    this.dataSourceDelivery = new MatTableDataSource(this.dataTable4);
    this.tableSelect = 4;

    setTimeout(() => {
      this.asignarSortsTable1_1();
    });

    this.isTabDisable = {
      tab1: true,
      tab2: true,
      tab3: false,
    };
    this.selectedTabIndex = 2;
    if (this.dialogActive) {
      this.openDialogConfirm();
      this.dialogActive = false;
    }

    this.totalItemsTable4 = res?.totalItems;

    setTimeout(() => {
      if (this.paginator2) {
        this.paginator4.length = this.totalItemsTable4;
      }
    }, 0);
  }

  private findDistribution(
    id: string,
    step: number,
    pageIndex: number,
    pageLimit: number,
    search?: string,
    state?: number
  ) {
    const option: IOptionFilterDistribution = {
      id,
      indexPage: pageIndex + 1,
      limit: pageLimit,
      sort: this.sortTables,
      search,
      state,
    };
    this.idIndex = id;
    this.saleDistributionService
      .findPaginationDistribution(option)
      .subscribe((res: any) => {
        const data = res.data;
        switch (step) {
          case 1:
            this.totalItemsTable1 = res?.totalItems;

            setTimeout(() => {
              if (this.paginator) {
                this.paginator.length = this.totalItemsTable1;
              }
            });
            this.resultScreen1_1(data);
            break;
          case 2:
            this.resultScreen1_2(res);
            break;
          case 3:
            this.resultScreen2(res);
            break;
          case 4:
            this.resultScreen3(res);
            break;
        }
      });
  }

  // Feach Sales distribution
  private feachMaterial(data: IFilterMaterial): void {
    this.saleDistributionService
      .postAllOrderDistribution(data)
      .subscribe((res: any) => {
        this.noSelectedOrders.value = res.noSelectedOrders;
        this.noSelectedOrders.load = 100;
        this.noSelectedOrders.value > 0 &&
          this.openDialogAlert(res.noSelectedOrders);

        this.findDistribution(
          res._id,
          1,
          this.pageIndexTable1,
          this.pageSizeTable1
        );

        this.UMPActive = this.companyList.filter(
          (item) => item._id.toString() === data.companyId
        )[0]?.UMPActive;

        this.temporalId = res._id;

        // this.fechProductNotSelect(data); // Solo llamar con temporalId
        // this.fechProductSelect(data);
        // this.fechDistributionClient(data);
        // this.fechProductNotSelect({
        //   ...data,
        //   temporalId: res._id,
        // });
      });
  }

  private fetchOrderAvalible(file: File, filter: IFilterMaterial) {
    this.saleDistributionService
      .postAllOrderDistributionAviable(file, filter)
      .subscribe((res: any) => {
        this.findDistribution(
          res._id,
          2,
          this.pageIndexTable2,
          this.pageSizeTable2
        );
      });
  }

  private fetchDistrubution(filter: IFilterMaterial, data: any): void {
    this.saleDistributionService
      .postDistributionCharge(filter, data)
      .subscribe((res: any) => {
        this.findDistribution(
          res._id,
          3,
          this.pageIndexTable3,
          this.pageSizeTable3
        );
      });
  }

  private fetchOrderSaveDistribution(next, dataFilter?: IFilterMaterial): void {
    const listDetails = this.orderDetails.map((order) => ({
      orderId: order.orderId,
      position: order.position,
      quantity: order.quantity,
      temporalId: order.temporalId,
      materialId: order.materialId,
    }));

    this.saleDistributionService
      .pacthOrderDetails(listDetails)
      .subscribe((res: any) => {
        this.advanceProductLoad();
        if (next) {
          this.dialogActive = true;
          this.findDistribution(
            this.idIndex,
            4,
            this.pageIndexTable4,
            this.pageSizeTable4
          );

          //   this.feachMaterialDelivery(dataFilter);
        }
      });
  }

  // private fechProductNotSelect(filter: any) {
  //   this.saleDistributionService
  //     .findOrderNotLoad(filter, {
  //       id: "",
  //       indexPage: this.pageIndexCard,
  //       limit: this.pageSizeCard,
  //       sortBy: "name",
  //       sort: this.sortOrder,
  //     })
  //     .subscribe((res: any) => {
  //       this.dataInfoCard[0].list = res.data;
  //       this.dataInfoCard[0].total = res.total;
  //       this.dataInfoCard[0].totalPages = res.totalPages;

  //       if (this.dialogRefInfo && this.dialogRefInfo != null) {
  //         this.dialog.closeAll();
  //         this.openDialogInfo(0);
  //         /*
  //         this.dialogRefInfo.componentInstance = {
  //           data: {
  //             ...this.dataInfoCard[0],
  //             option: 0,
  //           },
  //         };
  //        */
  //       } else {
  //         this.pageIndexCard = 1;
  //       }
  //     });
  // }

  // private fechProductNotSelect(filter: any) {
  //   this.saleDistributionService
  //     .findOrderNotLoad(
  //       {
  //         currentPage: this.pageIndexCard,
  //         limitPerPage: this.pageSizeCard,
  //         search: this.searchQuery,
  //         sortDirection: "ASC",
  //         sort: "serial" as keyof OrderAttributes,
  //       },
  //       filter
  //     )
  //     .subscribe({
  //       next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
  //         this.dataInfoCard[0].list = res?.data[0]?.data ?? [];
  //         this.dataInfoCard[0].total = res?.data[0]?.pageInfo?.[0]?.total ?? 0;

  //         // ✅ Solo actualizar data, no cerrar modal
  //         if (this.dialogRefInfo && this.dialogRefInfo.componentInstance) {
  //           this.dialogRefInfo.componentInstance.data = {
  //             ...this.dataInfoCard[0],
  //             option: 0,
  //           };
  //         } else {
  //           this.pageIndexCard = 1;
  //         }
  //       },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al obtener información de los pedidos.",
  //           "Cerrar",
  //           { duration: 5000 }
  //         );
  //       },
  //     });
  // }

  private fechProductNotSelect(filter: any) {
    return this.saleDistributionService.findOrderNotLoad(
      {
        currentPage: this.pageIndexCard,
        limitPerPage: this.pageSizeCard,
        search: this.searchQuery,
        sortDirection: "ASC",
        sort: "serial" as keyof OrderAttributes,
      },
      filter
    );
  }

  private fechProductSelect(filter: any) {
    return this.saleDistributionService.findOrderLoad(
      {
        currentPage: this.pageIndexCard,
        limitPerPage: this.pageSizeCard,
        search: this.searchQuery,
        sortDirection: "ASC",
        sort: "serial" as keyof OrderAttributes,
      },
      filter
    );
  }

  private fechDistributionClient(filter: any) {
    return this.saleDistributionService.findDistributionClient(
      {
        currentPage: this.pageIndexCard,
        limitPerPage: this.pageSizeCard,
        search: this.searchQuery,
        sortDirection: "ASC",
        sort: this.sortOrder as keyof OrderAttributes,
      },
      filter
    );
  }

  private fechUmActive(selected: number, materialId) {
    const data: IumActive = {
      temporalId: this.idIndex,
      materialId,
      selected,
    };

    this.saleDistributionService.postUMTemporal(data).subscribe((res: any) => {
      this.findDistribution(
        res._id,
        1,
        this.pageIndexTable1,
        this.pageSizeTable1
      );
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  get goToAssistantDeliveryQueryParams(): Params {
    return {
      [LOAD_COMPONENT_QUERY_PARAMS.forceInitialTabId.queryParam]:
        LoadComponentTabIds.ORDERS_WITHOUT_TRIP,
    };
  }

  public onSearchInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const searchText = target.value.trim();
    this.searchQuery = searchText;
    this.pageIndexCard = 1;
    this.servicesFuntion(this.sortTables, this.pageIndexCard);
  }

  getActionIcon(): string {
    switch (this.currentStep) {
      case 1:
        return "play_arrow"; // Continuar
      case 2:
        return this.hasProcessed ? "file_download" : "save"; // Exportar o Guardar
      default:
        return ""; // Paso 0 usa SVG, no este
    }
  }

  getActionTooltip(): string {
    switch (this.currentStep) {
      case 0:
        return "Importar archivo";
      case 1:
        return "Continuar";
      case 2:
        return this.hasProcessed ? "Exportar Todo" : "Procesar y continuar";
      default:
        return "";
    }
  }

  handleDynamicAction() {
    switch (this.currentStep) {
      case 0:
        // para cargar el excel
        if (
          !this.checkIfHasPermission(
            ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.IMPORT,
            "No tienes permisos para importar archivos de distribución de ventas"
          )
        )
          return;
        this.hiddenfileinput.nativeElement.click();
        break;
      case 1:
        if (
          !this.checkIfHasPermission(
            ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.CREATE,
            "No tienes permisos para procesar la distribución de ventas"
          )
        )
          return;
        this.handleNext(); // acción Continuar
        this.currentStep = 2;
        break;
      case 2:
        if (!this.hasProcessed) {
          if (
            !this.checkIfHasPermission(
              ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.CREATE,
              "No tienes permisos para procesar la distribución de ventas"
            )
          )
            return;
          this.openDialogSave(true); // acción Procesar y continuar
        } else {
          if (
            !this.checkIfHasPermission(
              ASSISTANT_DISTRIBUTION_STOCK_PERMISSIONS.EXPORT,
              "No tienes permisos para exportar la distribución de ventas"
            )
          )
            return;
          this.handleExportAll(); // acción Exportar Todo
        }
        break;
    }
  }

  /**
   * Check if has permission
   */
  checkIfHasPermission(permission: string, errorMessage?: string): boolean {
    const hasPermission = this.permissionService.has(permission);

    if (!hasPermission && errorMessage) {
      this.handlerMessage.error({ message: errorMessage });
    }

    return hasPermission;
  }
}
